export default "__VITE_ASSET__391bf0ab__"